"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SurveyStore = /*#__PURE__*/function (_RootStore) {
  function SurveyStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, SurveyStore);
    _this = _callSuper(this, SurveyStore);
    _this.config = {
      model: _models.Survey,
      deserialize: true,
      GET: {
        index: '/surveys',
        show: '/surveys/:surveySlug',
        bySlug: '/surveys/by_slug/:surveySlug',
        exportResults: '/surveys/:surveyId/export_results',
        analytics: '/surveys/:surveyId/analytics'
      },
      POST: {
        create: '/surveys'
      },
      PUT: {
        update: '/surveys/:surveyId'
      },
      DELETE: {
        destroy: '/surveys/:surveyId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(SurveyStore, _RootStore);
  return (0, _createClass2["default"])(SurveyStore, [{
    key: "getBySlug",
    value: function getBySlug(params, callback) {
      this.api(params, callback, 'GET', 'bySlug');
    }
  }, {
    key: "getAnalytics",
    value: function getAnalytics(params, callback) {
      return this.api(params, callback, 'GET', 'analytics');
    }
  }, {
    key: "exportResultsPromise",
    value: function exportResultsPromise(params) {
      return this.apiPromise(params, 'GET', 'exportResults');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new SurveyStore();